<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>TRADERS</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">                       
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> 
                        <button @click="switchAccount()"  type="button" class="btn btn-success rounded"><i class="fas fa-toggle-on"></i> SWITCH ACCOUNT</button>            
                        <router-link to="/ims/admin-users" v-if="isAdmin">
                            <button  type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW TRADER</button>
                        </router-link>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                                    @click="sort('firstName')" >TRADER</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >ID</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >TMC ACCOUNT NO</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >BONDPOINT ACCOUNT NO</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >TRADEWEB ACCOUNT NO</th>
                                   <th 
                                    scope="col" 
                                    class="sort text-center"
                                   >MarketAxess ACCOUNT NO</th>    
                               <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'rankId'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'rankId'  ? 'sort-desc' : '']"  
                                    @click="sort('rankId')"> RANK</th>
                                <!--  <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maxParValue'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maxParValue'  ? 'sort-desc' : '']"  
                                    @click="sort('maxParValue')">Max. Par Value/Cusip</th>
                                    
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maxCapital'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maxCapital'  ? 'sort-desc' : '']"  
                                    @click="sort('maxCapital')">Max. Capital</th>       -->
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="trader in traders" :key="trader.id">
                                <td class="text-center">{{trader.firstName }} {{trader.lastName}}</td>
                                <td class="text-center">{{trader.traderId ? trader.traderId : "N/A" }}</td>
                                <td class="text-center">{{getAccountName(trader.tmcAccountId)}}</td>
                                <td class="text-center">{{getAccountName(trader.ibpAccountId)}}</td>
                                <td class="text-center">{{getAccountName(trader.twdAccountId)}}</td>
                                <td class="text-center">{{getAccountName(trader.mktxAccountId)}}</td>
                                <td class="text-center">{{ trader.rankId }}</td>
                                <!-- <td class="text-center">{{trader.offerMaxCusips ? trader.offerMaxCusips : 'N/A'}}</td>
                                <td class="text-center">{{trader.offerMaxParValue ? trader.offerMaxParValue : 'N/A'}}</td>
                                <td class="text-center">{{trader.offerMaxCapital ? trader.offerMaxCapital : 'N/A'}}</td> -->
                                <td class="text-center">
                                    <button @click="openEditTraderModal(trader)" class="btn ibtn btn-outline-primary" title="Customers"><i class="far fa-edit"></i></button>                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <traderedit
            v-bind:traderData="traderData" 
            v-if="traderEditModalOpen" 
            @close="closetraderEditModal()"
        />
    </div>      
</template>
<script>
import traderedit from "./ImsTraderEditModal";
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imstradersComponent",
  components : {
      traderedit
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "firstName",
        sortOrder: "ASC",
        traderData : null,
        traderEditModalOpen : false,
        traders : [],
        accountList : [],
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        
     
    };
  },
  methods: {
    switchAccount(){
        this.$confirm("Are you sure you want to switch account?","Switch Account","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .put(
                config.baseUrlBidSide +
                    "/account/switch","",
                    auth
                )
                .then(() => {
                    this.getTraderList();
                })
        })
    },
    openEditTraderModal(data){
        this.traderData = {...data}
        this.traderEditModalOpen = true
    },
    closetraderEditModal(){
        this.traderEditModalOpen = false;
        this.getTraderList();
    },
    searchTrader(){
        this.getTraderList();
    },
    clearSearch(){
        this.searchValue = "";
        this.getTraderList();
    },
    getAccountName(id){
        return id ? this.accountList.find(x => x.id === id).account : 'N/A';
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getTraderList();
    },
    getTraderList(){
        this.loading = true;
        
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/trader/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=Trader",
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.traders = result.data.content;
          this.loading = false;
        })
    },
    getBrokerAccountList(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD,MKTX",
            auth
            )
            .then(response => {
               this.accountList = response.data
            })
            .catch(e => {
            console.log(e);
            });
    }
  },
  mounted() {
    this.getTraderList();
    this.getBrokerAccountList();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
    });
  }
};
</script>